import React, { useState } from 'react'
import { Link } from 'gatsby'
import tw from 'twin.macro'
import { css } from '@emotion/react'

import { ButtonStyle, CopyLGStyle, CopyStyle } from './UI'

// Assets
import logo from '../images/staffy-wordmark-orange.svg'

const Navigation = () => {
  const [expanded, setExpanded] = useState(false)

  const toggleMobileNav = () => {
    setExpanded(!expanded)
  }

  return (
    <>
      <nav
        css={[
          tw`fixed w-full max-h-screen bg-[#202C3A] text-white flex flex-col z-50 lg:(w-full static block h-auto)`,
          expanded && tw`h-screen`,
        ]}
      >
        {/* Main Nav */}
        <div tw="w-full flex justify-between h-20">
          {/* Internal Links */}
          <div tw="ml-4 lg:ml-14">
            <ul css={[ButtonStyle, tw`h-full flex items-center text-center`]}>
              <li tw="lg:mr-3">
                <Link to="/">
                  <img src={logo} />
                </Link>
              </li>
              <li tw="mx-3 hidden lg:block transition-property[color] transition-duration[0.2s] transition-timing-function[cubic-bezier(0.645,0.045,0.355,1)] hover:text-[#FF4D00]">
                <Link to="/start-earning">Start earning</Link>
              </li>
              <li tw="mx-3 hidden lg:block transition-property[color] transition-duration[0.2s] transition-timing-function[cubic-bezier(0.645,0.045,0.355,1)] hover:text-[#FF4D00]">
                <Link to="/find-talent">Find talent</Link>
              </li>
              <li tw="mx-3 hidden lg:block transition-property[color] transition-duration[0.2s] transition-timing-function[cubic-bezier(0.645,0.045,0.355,1)] hover:text-[#FF4D00]">
                <Link to="/jobs">Jobs</Link>
              </li>
              <li tw="mx-3 hidden lg:block transition-property[color] transition-duration[0.2s] transition-timing-function[cubic-bezier(0.645,0.045,0.355,1)] hover:text-[#FF4D00]">
                <Link to="/about">About</Link>
              </li>
              <li tw="mx-3 hidden lg:block transition-property[color] transition-duration[0.2s] transition-timing-function[cubic-bezier(0.645,0.045,0.355,1)] hover:text-[#FF4D00]">
                <Link to="/faq">FAQ</Link>
              </li>
              <li tw="mx-3 hidden lg:block transition-property[color] transition-duration[0.2s] transition-timing-function[cubic-bezier(0.645,0.045,0.355,1)] hover:text-[#FF4D00]">
                <Link to="/blog">Blog</Link>
              </li>
              <li tw="mx-3 hidden lg:block transition-property[color] transition-duration[0.2s] transition-timing-function[cubic-bezier(0.645,0.045,0.355,1)] hover:text-[#FF4D00]">
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </div>
          {/* External CTAs */}
          <div tw="hidden lg:block">
            <ul css={[ButtonStyle, tw`h-full flex items-center text-center`]}>
              {/* Partner login */}
              <li tw="px-8">
                <a
                  href="https://app.staffy.com/auth/login"
                  target="_blank"
                  rel="noreferrer"
                  tw="transition-property[color] transition-duration[0.2s] transition-timing-function[cubic-bezier(0.645,0.045,0.355,1)] hover:text-[#FF4D00]"
                >
                  Partner&nbsp;login
                </a>
              </li>
              {/* Send app */}
              <li tw="h-full">
                <Link
                  tw="w-full h-full bg-[#FF4D00] text-white px-14 flex justify-center items-center"
                  to="/app"
                >
                  Download the app
                </Link>
              </li>
            </ul>
          </div>
          {/* Mobile Hamburger Icon */}
          <div tw="mr-4 lg:hidden flex items-center">
            {!expanded && (
              <button onClick={toggleMobileNav}>
                <hr tw="w-7 mb-2 border-white" />
                <hr tw="w-7 my-2 border-white" />
                <hr tw="w-7 mt-2 border-white" />
              </button>
            )}

            {expanded && (
              <button onClick={toggleMobileNav}>
                <hr
                  css={[
                    tw`w-7 border-white`,
                    css`
                      transform: rotate(45deg);
                    `,
                  ]}
                />
                <hr
                  css={[
                    tw`w-7 border-white`,
                    css`
                      transform: rotate(-45deg);
                    `,
                  ]}
                />
              </button>
            )}
          </div>
        </div>
        {/* Expanded Nav */}
        <div
          css={[
            tw`hidden flex-grow flex-col justify-between bg-[#202C3A] overflow-auto lg:hidden`,
            expanded && tw`flex`,
          ]}
        >
          {/* Mobile - Internal Links */}
          <div>
            <ul css={[CopyStyle, tw`text-[21px]`]}>
              <li>
                <Link tw="block pl-8 py-4" to="/start-earning">
                  Start earning
                </Link>
              </li>
              <li>
                <Link tw="block pl-8 py-4" to="/find-talent">
                  Find talent
                </Link>
              </li>
              <li>
                <Link tw="block pl-8 py-4" to="/jobs">
                  Jobs
                </Link>
              </li>
              <li>
                <Link tw="block pl-8 py-4" to="/about">
                  About
                </Link>
              </li>
              <li>
                <Link tw="block pl-8 py-4" to="/blog">
                  Blog
                </Link>
              </li>
              <li>
                <Link tw="block pl-8 py-4" to="/contact">
                  Contact
                </Link>
              </li>
              <li>
                <Link tw="block pl-8 py-4" to="/faq">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>
          {/* Mobile - External CTAs */}
          <div>
            <ul css={[CopyStyle, tw`flex flex-col items-center`]}>
              {/* Partner login */}
              <li tw="w-full">
                <a
                  tw="w-full bg-[#F1FAFD] text-black text-[21px] px-8 py-4 flex justify-center items-center"
                  href="https://app.staffy.com/auth/login"
                  target="_blank"
                  rel="noreferrer"
                >
                  Partner&nbsp;login
                </a>
              </li>
              {/* Send app */}
              <li tw="w-full">
                <Link
                  tw="w-full bg-[#FF4D00] text-white text-[21px] px-8 py-6 flex justify-center items-center"
                  to="/app"
                >
                  Download the app
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      {/* Mobile - Top spacer behind fixed nav */}
      <div tw="block lg:hidden w-full h-20"></div>
    </>
  )
}

export default Navigation
